import Countdown from './countdown';

const STATUS_CONTAINER = '#auction-status-container';
const DIALOG = '#auction-dialog';

function updateAuctionSidebarModule(html) {
  const auctionStatus = $(STATUS_CONTAINER);


  const auctionStatusParent = auctionStatus.parent();
  auctionStatus.html(html);
  auctionStatusParent.highlight();
}

function displayOutbidStatus(outbidHtml) {
  updateAuctionStatus((dialog) => {
    dialog
      .removeClass('alert alert-success')
      .html(outbidHtml)
      .height('auto');
  });
}

function displayHighBidder(successHtml) {
  const auctionStatus = $(STATUS_CONTAINER);

  updateAuctionStatus(() => {
    $.fancybox.close();
    updateAuctionSidebarModule(successHtml);
  });
}

function updateAuctionStatus(callback) {
  const dialog = $(DIALOG).parent();
  Reverb.UI.spinWithMessage(dialog, 'Placing bid...');
  setTimeout(() => {
    callback(dialog);
    Countdown.init();
  }, 500);
}

export default {
  updateAuctionSidebarModule,
  displayOutbidStatus,
  displayHighBidder,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/bid_response_handler.js